import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  swap({ source, target, scopes }) {
    return window.axios.post(`${this.url}/swap`, { source, target, scopes });
  }
}

export default new LabelsAPI();
